import * as yup from 'yup';

export const createValidatorFromYupSchema = (validator: yup.Schema) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (data: any) => {
    try {
      validator.validateSync(data);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return false;
    }
    return true;
  };
};
